import {Component} from '@angular/core';
import {GenericChartModel} from '../generic-chart.model';

@Component({
  selector: 'cmp-chart-amchart-column',
  template: `<cmp-chart-amchart  [loading]="loading"
                    [chartData]="buildData"
                    [noResults]="noResults || {}">
</cmp-chart-amchart>
`,
  styles: [``]
})
export class ChartAmchartColumnComponent extends GenericChartModel {

  constructor() {
    super();
  }

  getData(seriesArg, chartName = '') {
      const series = JSON.parse(JSON.stringify(seriesArg));
      const chartData = [];
      const graphData = [];
      const legendData = [];
      const isMultiple = series.length > 1;
      let valueAxisLogarithmic = null;

      if (isMultiple) {
        let values = series.map(superElement => {
          return superElement.values.map(elementChart => {
            return elementChart.value;
          });
        });
        let mergedValues = [].concat.apply([], values);
        valueAxisLogarithmic = this.configData.customLogarithmic ? GenericChartModel.isLogarithmic(mergedValues) : false;
        let isText = false;
        series.forEach((superElementChart, j) => {
          const valueField = superElementChart.name ? superElementChart.name : j.toString();
          if (j === 0) {
            isText = superElementChart.name ? true : false;
          }
          legendData.push({title: valueField, color: valueField && this.configData.colorGraph[valueField] ?
              this.configData.colorGraph[valueField] :
              this.graphData.CSS_COLOR_CORPORATIVE[j % this.graphData.CSS_COLOR_CORPORATIVE.length]});
          superElementChart.values.forEach((elementChart) => {
            const rd = chartData.findIndex(
              d => d[this.configData.categoryField] === (this.configData.isTimeStamp ?
                GenericChartModel.getHumanReadableDateYearMonthDay(elementChart.key) :
                elementChart.key)
            );
            if ((rd || rd === 0) && chartData[rd]) {
              chartData[rd][valueField] = valueAxisLogarithmic ?
                (elementChart.value === 0 ? 1 : elementChart.value.toFixed(1)) :
                elementChart.value.toFixed(1);
              chartData[rd]['color' + valueField] = valueField && this.configData.colorGraph[valueField] ?
                this.configData.colorGraph[valueField] :
                this.graphData.CSS_COLOR_CORPORATIVE[j % this.graphData.CSS_COLOR_CORPORATIVE.length];
            } else {
              const tempObj: any = {};
              tempObj[this.configData.categoryField] = this.configData.isTimeStamp ?
                GenericChartModel.getHumanReadableDateYearMonthDay(elementChart.key) :
                elementChart.key;
              tempObj[valueField] = valueAxisLogarithmic ?
                (elementChart.value === 0 ? 1 : elementChart.value.toFixed(1)) :
                elementChart.value.toFixed(1);
              tempObj['color' + valueField] = valueField && this.configData.colorGraph[valueField] ?
                this.configData.colorGraph[valueField] :
                this.graphData.CSS_COLOR_CORPORATIVE[j % this.graphData.CSS_COLOR_CORPORATIVE.length];
              chartData.push(tempObj);
            }
          });
          const tempGraphObject = <any>{
            id: 'g' + valueField,
            type: 'column',
            title: valueField,
            valueField: valueField,
            colorField: 'color' + valueField
          };

          if (this.configData.lineConfig) {
            if (this.configData.lineConfig.fillAlphas != null) {
              tempGraphObject.fillAlphas = this.configData.lineConfig.fillAlphas;
            }
            if (this.configData.lineConfig.lineAlpha != null) {
              tempGraphObject.lineAlpha = this.configData.lineConfig.lineAlpha;
            }
          }

          if (this.configData.balloonText && this.configData.balloonCustomFunction) {
            tempGraphObject.balloonFunction = (item, graph) => {
              return (isText ?
                `<span style='font-family: helvetica' style='font-size:12px;'>${item.category} ${graph.title}: <b>${this.getConverter(
                  item.values.value
                )}</span></b>` :
                `<span style='font-family: helvetica' style='font-size:12px;'>${item.category} <b>${this.getConverter(
                  item.values.value
                )}</span></b>`);
            };
          } else if (this.configData.balloonText) {
            tempGraphObject.balloonText = name ?
              `<span style='font-family: helvetica' style='font-size:12px;'>[[category]] [[title]]: <b>[[value]]</b></span>` :
              `<span style='font-family: helvetica' style='font-size:12px;'>[[category]]  <b>[[value]]</b></span>`
          } else if (this.configData.balloonCustomFunction) {
            tempGraphObject.balloonFunction = (item, graph) => {
              return `<span style='font-family: helvetica' style='font-size:12px;'>${this.getConverter(
                item.values.value
              )}</span>`;
            };
          }
          graphData.push(tempGraphObject);
        });
      } else {
        let values = series[0].values.map(elementChart => {
          return elementChart.value;
        });
        let mergedValues = [].concat.apply([], values);
        valueAxisLogarithmic = this.configData.customLogarithmic ? GenericChartModel.isLogarithmic(mergedValues) : false;
        const name = series[0].name != null ? series[0].name : chartName;
        legendData.push({title: name, color: name && this.configData.colorGraph[name] ?
            this.configData.colorGraph[name] :
            this.graphData.CSS_COLOR_CORPORATIVE[0]});
        series[0].values.forEach(elementChart => {
          const tempObj: any = {};
          tempObj[this.configData.categoryField] = this.configData.isTimeStamp ?
            GenericChartModel.getHumanReadableDateYearMonthDay(elementChart.key) :
            elementChart.key;
          tempObj.color = this.configData.categoryField &&
          tempObj[this.configData.categoryField] && this.configData.colorGraph[tempObj[this.configData.categoryField]] ?
            this.configData.colorGraph[tempObj[this.configData.categoryField]] :
            this.graphData.CSS_COLOR_CORPORATIVE[0];
          tempObj[name] = valueAxisLogarithmic ?
            (elementChart.value === 0 ? 1 : elementChart.value.toFixed(1)) :
            elementChart.value.toFixed(1);
          chartData.push(tempObj);
        });

        const tempGraphObject = <any>{
          id: 'g' + name,
          type: 'column',
          title: name,
          valueField: name,
          fillColorsField: 'color'
        };

        if (this.configData.lineConfig) {
          if (this.configData.lineConfig.fillAlphas != null) {
            tempGraphObject.fillAlphas = this.configData.lineConfig.fillAlphas;
          }
          if (this.configData.lineConfig.lineAlpha != null) {
            tempGraphObject.lineAlpha = this.configData.lineConfig.lineAlpha;
          }
        }

        if (this.configData.balloonText && this.configData.balloonCustomFunction) {
          tempGraphObject.balloonFunction = (item, graph) => {
            return (name ?
              `<span style='font-family: helvetica' style='font-size:12px;'>${item.category} ${graph.title}: <b>${this.getConverter(
                item.values.value
              )}</span></b>`:
              `<span style='font-family: helvetica' style='font-size:12px;'>${item.category} <b>${this.getConverter(
                item.values.value
              )}</span></b>`);
          };
        } else if (this.configData.balloonText) {
          tempGraphObject.balloonText = name
            ? `<span style='font-family: helvetica' style='font-size:12px;'>[[category]] [[title]]: <b>[[value]]</b></span>`
            : `<span style='font-family: helvetica' style='font-size:12px;'>[[category]]  <b>[[value]]</b></span>`
        } else if (this.configData.balloonCustomFunction) {
          tempGraphObject.balloonFunction = (item, graph) => {
            return `<span style='font-family: helvetica' style='font-size:12px;'>${this.getConverter(
              item.values.value
            )}</span>`;
          };
        }
        graphData.push(tempGraphObject);
      }

      if (this.configData.isLegend) {
        this.legendData = {
          align: 'left',
          position: 'bottom',
          markerSize: 10,
          marginTop: 20,
          valueWidth: 120,
          valueText: ``,
        };
        if (legendData && legendData.length > 0 && this.configData.isLegend) {
          this.legendData.data = legendData;
        }
      }

      if (this.configData.isSortable) {
        GenericChartModel.sortScore(chartData, this.configData.categoryField);
      }
      this.chartData = {data: chartData, graph: graphData};
  }

  parseData(chart, id = null, dataSet = [], index = null) {
    try {
      const yValues = chart['graphset'][0]['series'];
      const xValuesValues = chart['graphset'][0]['scaleX']['values'];
      const xValuesLabels = chart['graphset'][0]['scaleX']['labels'];
      const chartType = chart['graphset'][0]['type'];
      const basicData = dataSet.find(chartDataSet => {
        return chartDataSet.id === id;
      });
      const name = basicData ? basicData.title : '';

      let series = [];
      if (xValuesLabels) {
        series = yValues.map((superElement, j) => {
          const valueField = superElement.text ? superElement.text : j.toString();
          const tempvalueArray = superElement.values.map((chartElement, i) => {
            return {
              key: xValuesLabels[i],
              value: chartElement
            };
          });
          return {
            name: valueField,
            values: tempvalueArray
          };
        });
      } else {
        series = yValues.map((superElement, j) => {
          const valueField = superElement.text ? superElement.text : j.toString();
          const tempvalueArray = superElement.values.map((chartElement, i) => {
            return {
              key: xValuesValues[i],
              value: chartElement
            };
          });
          return {
            name: valueField,
            values: tempvalueArray
          };
        });
      }
      const graph = {
        title: basicData ? basicData.title : '',
        xlabel: '',
        ylabel: '',
        type: chartType,
        series
      };
      return {name, graph, id, index};
    } catch (error) {
      return {id, index};
    }
  }
}
